import React, { Component, Fragment } from 'react';
import { Grid, Form, Segment, List, Message } from 'semantic-ui-react';

class QuestionForm extends Component {
  state = {};

  onChange = (e, { name, value }) => this.setState({ [name]: value, [`${name}Error`]: undefined });

  onSubmit = () => {
    let {
      nameError,
      contactInfoError,
      questionError,
    } = this.state;
    const {
      name,
      contactInfo,
      question,
    } = this.state;
    if (!name) {
      nameError = 'Vul uw naam in a.u.b.';
    }
    if (!contactInfo) {
      contactInfoError = 'Vul uw contactinfo in a.u.b.';
    }
    if (!question) {
      questionError = 'Formuleer uw vraag a.u.b.';
    }
    this.setState({ nameError, contactInfoError, questionError });
    if (!nameError && !contactInfoError && !questionError) {
      fetch('/mail.php', {
        method: 'POST',
        body: JSON.stringify({ name, contactInfo, question }),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(this.setState({ submitSuccess: true }))
        .catch(error => this.setState({ httpError: error }));
    }
  }

  render() {
    const {
      name,
      nameError,
      contactInfoError,
      contactInfo,
      questionError,
      question,
      httpError,
      submitSuccess,
    } = this.state;
    const error = questionError || contactInfoError || nameError || httpError;
    return (
      <Fragment>
        <Grid.Row centered>
          <h3>Stel zelf een vraag</h3>
        </Grid.Row>
        <Grid.Row fluid>
          <Form
            error={error}
            success={submitSuccess}
            as={Segment}
            className="Questions__Form"
          >
            <p>
              Heb je het antwoord op jouw vraag niet gevonden?
              Dan kunt u hier uw vraag stellenen nemen we contact
              met u op om deze te beantwoorden.
            </p>
            <Form.Input
              fluid
              className="Questions__Form__Item"
              name="name"
              label="Uw naam"
              required
              error={nameError}
              placeholder="Uw naam"
              onChange={this.onChange}
              value={name}
            />
            <Form.Input
              fluid
              className="Questions__Form__Item"
              name="contactInfo"
              label="Uw e-mail of mobiel nummer"
              required
              error={contactInfoError}
              placeholder="Uw contactinformatie"
              onChange={this.onChange}
              value={contactInfo}
            />
            <Form.TextArea
              fluid
              label="Formuleer de vraag"
              name="question"
              className="Questions__Form__Item"
              required
              error={questionError}
              placeholder="Vraag"
              onChange={this.onChange}
              value={question}
            />
            <Message error fluid>
              <List bulleted>
                {nameError && (
                <List.Item>
                  {nameError}
                </List.Item>
                )}
                {contactInfoError && (
                <List.Item>
                  {contactInfoError}
                </List.Item>
                )}
                {questionError && (
                <List.Item>
                  {questionError}
                </List.Item>
                )}
                {httpError && (
                <List.Item>
                  {httpError}
                </List.Item>
                )}
              </List>
            </Message>
            <Message
              success
              header="Vraag verstuurd!"
              content="Je vraag is opgestuurd en we zullen deze zo snel mogelijk behandelen."
            />
            <Form.Button onClick={this.onSubmit} content="Submit" />
          </Form>

        </Grid.Row>
      </Fragment>
    );
  }
}

export default QuestionForm;



// WEBPACK FOOTER //
// ./src/components/Questions/QuestionForm.js